import { FuseNavigationItem } from '@fuse/components/navigation';
import { Message } from 'app/layout/common/messages/messages.types';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { Shortcut } from 'app/layout/common/shortcuts/shortcuts.types';
import { Profile } from 'app/modules/profile/profile.model';
import { OptionsSelect as KeyValue } from './shared/ashcorp-controllers/select/select.component';

export interface InitialData {
    messages: Message[];
    navigation: {
        compact: FuseNavigationItem[],
        default: FuseNavigationItem[],
        futuristic: FuseNavigationItem[],
        horizontal: FuseNavigationItem[]
    };
    notifications: Notification[];
    shortcuts: Shortcut[];
    user: Profile;
}

export interface ToasterMessage {
    message: string;
    type: 'success' | 'error';
}

export interface ApiResponse<T = any> {
    id: string;
    httpCode: number;
    code: string;
    title: string;
    status: 'success' | 'error' | 'alert';
    payload: T;
    errors: T;
    message: string;
}

export interface ValidationError {
    error: string;
    name: string;
    label: string;
    type: string;
    received: string;
    expected: string;
    message: string;
}

export interface ValidationErrorPayload {
    [key: string]: ValidationError | string;
}

export interface Paged<T> {
    items: T[];
    count: number;
}

export const OPTIONS_STATUS: KeyValue = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' }
] as const;

export type OptionsStatus = typeof OPTIONS_STATUS[number];

export const OPTIONS_ROLE: KeyValue = [
    { label: 'Super Admin', value: '@SUPERADMIN' },
    { label: "Admin", value: "@ADMIN" },
    { label: "Manager", value: "@MANAGER" },
    { label: "User", value: "@USER" }
] as const;

export type OptionsRole = typeof OPTIONS_ROLE[number];

export const MODULE_COMPONENTS: KeyValue = [
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Accounts', value: 'accounts' },
    { label: 'Campaigns', value: 'campaigns' },
    { label: 'Payroll', value: 'payroll' },
    { label: 'Settings', value: 'settings' },
    { label: 'Users', value: 'users' }
] as const;

export type ModuleComponentOption = typeof MODULE_COMPONENTS[number];
export type ModuleComponent = ModuleComponentOption['value'];